import styled from '@emotion/styled';
import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from 'roo-ui/components';
import { themeGet } from 'styled-system';
import { mediaQuery } from 'lib/styledSystem';
import { getIsLoading, getResultsForActiveCategory } from 'store/promoArea/promoAreaSelectors';
import PromoResult from './PromoResult';
import { SkeletonResults } from 'pages/ListSearch/PromoArea/primitives';

export const Grid = styled(Box)`
  display: none;

  ${mediaQuery.minWidth.md} {
    display: flex;
    > * {
      width: 32%;
      margin-right: ${themeGet('space.5')};
    }
  }
`;

const PromoResults = () => {
  const results = useSelector(getResultsForActiveCategory);
  const isLoading = useSelector(getIsLoading);

  return (
    <Grid>
      {isLoading ? (
        <SkeletonResults />
      ) : (
        results.map((result, index) => <PromoResult key={`promo-deal-${index}`} index={index} {...result} />)
      )}
    </Grid>
  );
};

export default PromoResults;
